<script lang="ts">
    import CreateRose from "./CreateRose.svelte";
    import {roses} from "../rose";
    import {gtag, randomSample} from "../utils";
    import RoseCarousel from "./RoseCarousel.svelte";
    import NavigationButton from "../shared/NavigationButton.svelte";

    gtag('set', 'page_path', '/');
    gtag('event', 'page_view');
</script>

<svelte:head>
    <title>Roses UPC</title>
</svelte:head>

<div id="description-div">
    <p id="description-title">
        Crea i regala una rosa única, artística.
    </p>
    <p id="description-text">
        La intel·ligència artificial i la informàtica aplicades a l’art generen una imatge amb models de <i>deep
        learning</i>. Tria una rosa o crea’n una de pròpia. La imatge de la rosa és modificada per l’algorisme, que
        l’aproxima a l’estil de l’artista i al text introduït. Mira el vídeo per saber com es genera fent servir
        computació intensiva i càlculs complexos a gran velocitat.
    </p>
    <NavigationButton to="informacio" text="Vols saber-ne més?"></NavigationButton>
</div>

<div id="carousel-div">
    <h2>Opció 1: Escull i regala una Rosa UPC ja creada amb intel·ligència artificial</h2>
    <RoseCarousel roses="{randomSample($roses, 12)}"/>
    <NavigationButton to="galeria" text="Veure totes les roses"></NavigationButton>
</div>

<div id="creation-div">
    <h2>Opció 2: Crea i regala la teva pròpia Rosa UPC personalitzada</h2>
    <CreateRose/>
</div>

<style>

    #description-title {
        color: var(--main-color);
        font-size: 1.5em;
        font-weight: 500;
    }

    #description-text {
        color: var(--main-color);
        font-size: 1.25em;
        font-weight: 400;
    }

    #carousel-div {
        display: block;
        width: 60vw;
        margin: 5vh auto;
    }

    #description-div, #creation-div, #carousel-div {
        border-top: 3px solid var(--main-color);
        padding: 15px 0;
    }


    @media (max-width: 1000px) {
        #carousel-div {
            width: 75vw;
        }
    }

    @media (max-width: 800px) {
        #carousel-div {
            width: 85vw;
        }
    }

    @media (max-width: 500px) {
        #carousel-div {
            width: 90vw;
        }
    }
</style>